// extracted by css-extract-rspack-plugin
export default {"root":"_3AWVtnR-_6wzWk-RSImn9S","listHeader":"BBVbE0GSf4mJODBfANAe3","list":"_324gsdZBz6za-p6jOybIEj","listItem":"_2hWU3z55C_SShqx-eifRzB"};